<kl-detail-filter
  (onSaveFilter)="commitSave($event)"
  (onSelectFilter)="selectFilter($event)"
  (onCommitFilter)="commitFilter()"
  (onCloseFilter)="closeFilter()"
  (onClearAll)="clearAll()"
  (onCloseAlert)="alertShow = false"
  (onDeleteFromValues)="deleteFromValues($event)"
  (onDeleteSavedFilter)="deleteSavedFilter($event)"
  [filterList]="filterList"
  [saveForm]="saveForm"
  [alertMessage]="alertMessage"
  [alertShow]="alertShow"
  [currentFilter]="currentFilter"
  [selectedFilterValues]="selectedFilterValues"
>
  <form #filterForm="ngForm">
    <div class="filter-group" #documentDate>
      <div
        class="filter-group-heading ui-clickable"
        (click)="documentDate.collapsed = !documentDate.collapsed"
      >
        <p class="font-weight-light">
          {{ "document_date" | translate }}
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': documentDate.collapsed,
              'fa-angle-down': !documentDate.collapsed
            }"
          ></i>
        </p>
      </div>
      <div class="filter-group-content" [collapse]="!documentDate.collapsed">
        <div class="form-group my-1">
          <label for="document_date_first_date">
            <span class="font-weight-light">{{
              "first_date" | translate
            }}</span>
          </label>
          <div class="input-group" style="width: 90%">
            <p-calendar
              name="document_date_first_date"
              id="document_date_first_date"
              [locale]="locale"
              [dateFormat]="dateFormatString"
              [(ngModel)]="firstDocumentDate"
              [showIcon]="true"
              styleClass="dateInput"
              [style]="{ width: '90%' }"
            >
            </p-calendar>
          </div>
        </div>
        <div class="form-group my-1">
          <label for="document_date_last_date">
            <span class="font-weight-light">{{ "last_date" | translate }}</span>
          </label>
          <div class="input-group" style="width: 90%">
            <p-calendar
              name="document_date_last_date"
              id="document_date_last_date"
              [locale]="locale"
              [dateFormat]="dateFormatString"
              [(ngModel)]="lastDocumentDate"
              [showIcon]="true"
              styleClass="dateInput"
              [style]="{ width: '90%' }"
            >
            </p-calendar>
          </div>
        </div>
      </div>
    </div>
    <div class="filter-group" #approvalStatus>
      <div
        class="filter-group-heading ui-clickable"
        (click)="approvalStatus.collapsed = !approvalStatus.collapsed"
      >
        <p class="font-weight-light">
          {{ "approval_status" | translate }}
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': approvalStatus.collapsed,
              'fa-angle-down': !approvalStatus.collapsed
            }"
          ></i>
        </p>
      </div>
      <div class="filter-group-content" [collapse]="!approvalStatus.collapsed">
        <p-dropdown
          [emptyFilterMessage]="'not_found' | translate"
          #approvalStatusDropdown
          [options]="approvalStatusOptions"
          name="currentAccount_status"
          [(ngModel)]="approvalStatusValue"
          [style]="{ width: '90%' }"
        >
        </p-dropdown>
      </div>
    </div>
    <div class="filter-group" #currentAccountCode>
      <div
        class="filter-group-heading ui-clickable"
        (click)="currentAccountCode.collapsed = !currentAccountCode.collapsed"
      >
        <p class="font-weight-light">
          {{ "current_account_code" | translate }}
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': currentAccountCode.collapsed,
              'fa-angle-down': !currentAccountCode.collapsed
            }"
          ></i>
        </p>
      </div>
      <div
        class="filter-group-content"
        [collapse]="!currentAccountCode.collapsed"
      >
        <p-dropdown
          [emptyFilterMessage]="'not_found' | translate"
          name="currentAccount_code"
          #currentAccountCodeDropdown
          [(ngModel)]="currentAccountCodeExpressionValue"
          [options]="currentAccountExpressionOptions"
          autoWidth="false"
          [style]="{ width: '90%' }"
        ></p-dropdown>
        <div class="form-group my-1">
          <div class="input-group" style="width: 90%">
            <input
              type="text"
              [(ngModel)]="currentAccountCodeValue"
              #currentAccountCodeInput
              name="currentAccount_code_input"
              class="form-control form-control-sm"
            />
            <div class="input-group-append">
              <span
                class="input-group-text transparent"
                (click)="
                  setModal(
                    'current-account',
                    'CURRENT_ACCOUNT_CODE',
                    CurrentAccountList,
                    '02.01.01'
                  )
                "
              >
                <i class="fal fa-ellipsis-h"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="filter-group" #customerCode>
      <div
        class="filter-group-heading ui-clickable"
        (click)="customerCode.collapsed = !customerCode.collapsed"
      >
        <p class="font-weight-light">
          {{ "customer_code" | translate }}
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': customerCode.collapsed,
              'fa-angle-down': !customerCode.collapsed
            }"
          ></i>
        </p>
      </div>
      <div class="filter-group-content" [collapse]="!customerCode.collapsed">
        <p-dropdown
          [emptyFilterMessage]="'not_found' | translate"
          name="customer_code"
          #customerCodeDropdown
          [(ngModel)]="customerCodeExpressionValue"
          [options]="currentAccountExpressionOptions"
          autoWidth="false"
          [style]="{ width: '90%' }"
        ></p-dropdown>
        <div class="form-group my-1">
          <div class="input-group" style="width: 90%">
            <input
              type="text"
              [(ngModel)]="customerCodeValue"
              #customerCodeInput
              name="customer_code_input"
              class="form-control form-control-sm"
            />
            <div class="input-group-append">
              <span
                class="input-group-text transparent"
                (click)="
                  setModal(
                    'customer',
                    'CUSTOMER_CODE',
                    CustomerList,
                    '03.01.01'
                  )
                "
              >
                <i class="fal fa-ellipsis-h"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="filter-group" #user>
      <div
        class="filter-group-heading ui-clickable"
        (click)="user.collapsed = !user.collapsed"
      >
        <p class="font-weight-light">
          {{ "recording_user" | translate }}
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': user.collapsed,
              'fa-angle-down': !user.collapsed
            }"
          ></i>
        </p>
      </div>
      <div class="filter-group-content" [collapse]="!user.collapsed">
        <div class="form-group my-1">
          <p-dropdown
            [emptyFilterMessage]="'not_found' | translate"
            [style]="{ width: '250px' }"
            [options]="userOptions"
            [optionLabel]="'full_name'"
            [filter]="true"
            name="currentAccount_create_user"
            [(ngModel)]="userValue"
            [placeholder]="'unselected' | translate"
          ></p-dropdown>
        </div>
      </div>
    </div>
    <div class="filter-group" #currentAccountRecordDate>
      <div
        class="filter-group-heading ui-clickable"
        (click)="
          currentAccountRecordDate.collapsed =
            !currentAccountRecordDate.collapsed
        "
      >
        <p class="font-weight-light">
          {{ "record_date" | translate }}
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': currentAccountRecordDate.collapsed,
              'fa-angle-down': !currentAccountRecordDate.collapsed
            }"
          ></i>
        </p>
      </div>
      <div
        class="filter-group-content"
        [collapse]="!currentAccountRecordDate.collapsed"
      >
        <div class="form-group my-1">
          <label for="currentAccount_first_date">
            <span class="font-weight-light">{{
              "first_date" | translate
            }}</span>
          </label>
          <div class="input-group" style="width: 90%">
            <p-calendar
              name="currentAccount_first_tate"
              id="currentAccount_first_date"
              [locale]="locale"
              [dateFormat]="dateFormatString"
              [(ngModel)]="firstDate"
              [showIcon]="true"
              styleClass="dateInput"
              [style]="{ width: '90%' }"
            >
            </p-calendar>
          </div>
        </div>
        <div class="form-group my-1">
          <label for="currentAccount_last_date">
            <span class="font-weight-light">{{ "last_date" | translate }}</span>
          </label>
          <div class="input-group" style="width: 90%">
            <p-calendar
              name="currentAccount_last_date"
              id="currentAccount_last_date"
              [locale]="locale"
              [dateFormat]="dateFormatString"
              [(ngModel)]="lastDate"
              [showIcon]="true"
              styleClass="dateInput"
              [style]="{ width: '90%' }"
            >
            </p-calendar>
          </div>
        </div>
      </div>
    </div>
    <div class="filter-group" #lastChangedUser>
      <div
        class="filter-group-heading ui-clickable"
        (click)="lastChangedUser.collapsed = !lastChangedUser.collapsed"
      >
        <p class="font-weight-light">
          {{ "last_changed_user" | translate }}
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': lastChangedUser.collapsed,
              'fa-angle-down': !lastChangedUser.collapsed
            }"
          ></i>
        </p>
      </div>
      <div class="filter-group-content" [collapse]="!lastChangedUser.collapsed">
        <div class="form-group my-1">
          <p-dropdown
            [emptyFilterMessage]="'not_found' | translate"
            [options]="userOptions"
            [optionLabel]="'full_name'"
            [filter]="true"
            name="currentAccount_change_user"
            [(ngModel)]="lastChangedUserValue"
            [style]="{ width: '90%' }"
            [placeholder]="'unselected' | translate"
          ></p-dropdown>
        </div>
      </div>
    </div>
    <div class="filter-group" #lastChangedDate>
      <div
        class="filter-group-heading ui-clickable"
        (click)="lastChangedDate.collapsed = !lastChangedDate.collapsed"
      >
        <p class="font-weight-light">
          {{ "last_date_changed" | translate }}
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': lastChangedDate.collapsed,
              'fa-angle-down': !lastChangedDate.collapsed
            }"
          ></i>
        </p>
      </div>
      <div class="filter-group-content" [collapse]="!lastChangedDate.collapsed">
        <div class="form-group my-1">
          <label for="currentAccount_last_changed_first_date">
            <span class="font-weight-light">{{
              "first_date" | translate
            }}</span>
          </label>
          <div class="input-group" style="width: 90%">
            <p-calendar
              name="currentAccount_last_changed_first_date"
              id="currentAccount_last_changed_first_date"
              [locale]="locale"
              [dateFormat]="dateFormatString"
              [(ngModel)]="firstDateLastChanged"
              [showIcon]="true"
              styleClass="dateInput"
              [style]="{ width: '90%' }"
            >
            </p-calendar>
          </div>
        </div>
        <div class="form-group my-1">
          <label for="currentAccount_last_changed_last_date">
            <span class="font-weight-light">{{ "last_date" | translate }}</span>
          </label>
          <div class="input-group" style="width: 90%">
            <p-calendar
              name="currentAccount_last_changed_last_date"
              id="currentAccount_last_changed_last_date"
              [locale]="locale"
              [dateFormat]="dateFormatString"
              [(ngModel)]="lastDateLastChanged"
              [showIcon]="true"
              styleClass="dateInput"
              [style]="{ width: '90%' }"
            >
            </p-calendar>
          </div>
        </div>
      </div>
    </div>
  </form>
</kl-detail-filter>
